<template>
  <div>
    <Header />
    <div class="container">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>
      <div class="merchant">
        <h3>Apply Now For Merchant</h3>
        <form action="" @submit.stop.prevent="">
          <span class="pull-right"><strong>Step {{ step }} / {{ totalSteps }}</strong></span>

          <!-- STEP 1 : Company Details -->
          <div v-if="step === 1">
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <label>
                  <h3>Company Name*</h3>
                  <input type="text" v-model.trim="form.company_name" placeholder="Company Full Name" />
                </label>
              </div>
              <div class="col-lg-6">
                <label>
                  <h3>Owner's Full Name*</h3>
                  <input type="text" v-model.trim="form.owner_full_name" placeholder="Owner's Full Name" />
                </label>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <label>
                  <h3>Website URL</h3>
                  <input type="text" v-model.trim="form.website_url" placeholder="ex: https://www.businessname.com/" />
                </label>
              </div>
              <div class="col-lg-6">
                <label>
                  <h3>Business Registration Number*</h3>
                  <input type="text" v-model.trim="form.registration_number" placeholder="Registration Number" />
                </label>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <label>
                  <h3>Tax / VAT / PAN Number</h3>
                  <input type="text" v-model.trim="form.tax_number" placeholder="Tax Number" />
                </label>
              </div>
            </div>
          </div>

          <!-- STEP 2 : Company Address -->
          <div v-if="step === 2">
            <div class="row justify-content-between">
              <div class="col-lg-12">
                <label>
                  <h3>Company Address*</h3>
                  <input type="text" v-model.trim="form.company_address" placeholder="Street / Area / Building" />
                </label>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <label>
                  <h3>Country*</h3>
                  <select v-if="countryOptions.length" v-model="form.country" @change="onCountryChange">
                    <option value="">Select Country</option>
                    <option v-for="(c, index) in countryOptions" :key="index" :value="c.name">{{ c.name }}</option>
                  </select>
                  <input v-else type="text" v-model.trim="form.country" placeholder="Country" />
                </label>
              </div>
              <div class="col-lg-6">
                <label>
                  <h3>State / Province</h3>
                  <input type="text" v-model.trim="form.state" placeholder="State" />
                </label>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <label>
                  <h3>City*</h3>
                  <input type="text" v-model.trim="form.city" placeholder="City" />
                </label>
              </div>
              <div class="col-lg-6">
                <label>
                  <h3>Zip / Postal Code</h3>
                  <input type="text" v-model.trim="form.zip_code" placeholder="Zip Code" />
                </label>
              </div>
            </div>
          </div>

          <!-- STEP 3 : Contact Person -->
          <div v-if="step === 3">
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <label>
                  <h3>Contact Person Name*</h3>
                  <input type="text" v-model.trim="form.contact_person_name" placeholder="Contact Person Name" />
                </label>
              </div>
              <div class="col-lg-6">
                <label>
                  <h3>Contact Person Email*</h3>
                  <input type="text" v-model.trim="form.contact_person_email" placeholder="ex: yourname@example.com" />
                </label>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col-lg-3">
                <label>
                  <h3>Country Code*</h3>
                  <input type="text" v-model.trim="form.contact_person_country_code" placeholder="ex: 977" />
                </label>
              </div>
              <div class="col-lg-9">
                <label>
                  <h3>Contact Person Number*</h3>
                  <input type="text" v-model.trim="form.contact_person_number" placeholder="ex: 9800000000" />
                </label>
              </div>
            </div>
          </div>

          <!-- STEP 4 : Business Contact -->
          <div v-if="step === 4">
            <div class="row justify-content-between">
              <div class="col-lg-12">
                <label>
                  <h3>Business Email*</h3>
                  <input type="text" v-model.trim="form.business_email" placeholder="ex: business@example.com" />
                </label>
              </div>
            </div>
            <div class="row justify-content-between">
              <div class="col-lg-3">
                <label>
                  <h3>Country Code*</h3>
                  <input type="text" v-model.trim="form.business_phone_country_code" placeholder="ex: 977" />
                </label>
              </div>
              <div class="col-lg-9">
                <label>
                  <h3>Business Phone Number*</h3>
                  <input type="text" v-model.trim="form.business_phone_number" placeholder="ex: 9800000000" />
                </label>
              </div>
            </div>
          </div>

          <!-- STEP 5 : Preview / Modify / Confirm -->
          <div v-if="step === 5">
            <div class="row">
              <div class="col-12">
                <h3 class="preview-title">Please review your details before submitting</h3>
              </div>
            </div>

            <div class="preview-block" v-for="section in previewSections" :key="section.step">
              <div class="row justify-content-between align-items-center">
                <div class="col-8">
                  <h3 class="preview-heading">{{ section.title }}</h3>
                </div>
                <div class="col-4 text-right">
                  <a href="#" class="modify-link" @click.prevent="goToStep(section.step)">Modify</a>
                </div>
              </div>
              <div class="row preview-row" v-for="(item, i) in section.items" :key="i">
                <div class="col-lg-6 preview-label">{{ item.label }}</div>
                <div class="col-lg-6 preview-value">{{ item.value || '-' }}</div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <label class="confirm-label">
                  <input type="checkbox" class="confirm-box" v-model="confirmed" />
                  I confirm the information above is correct and complete.
                </label>
              </div>
            </div>
          </div>

          <!-- STEP 6 : Submitted -->
          <div v-if="step === 6">
            <div class="row">
              <div class="col-12">
                <h3 class="preview-title">{{ successText }}</h3>
                <p class="submitted-note">
                  Our team will review your application and contact you at
                  <strong>{{ form.contact_person_email }}</strong>.
                </p>
              </div>
            </div>
          </div>

          <!-- NAVIGATION -->
          <div class="row" v-if="step < 6">
            <div class="col-lg-3" v-if="step > 1">
              <button type="button" class="btn-back" @click="prevStep">
                <h3>Back</h3>
              </button>
            </div>
            <div class="col-lg-3" v-if="step < totalSteps">
              <button type="submit" @click="nextStep">
                <h3>Next</h3>
              </button>
            </div>
            <div class="col-lg-4" v-if="step === totalSteps">
              <button type="button" @click="askConfirm" :disabled="isLoading">
                <h3>{{ isLoading ? "Submitting..." : "Submit Request" }}</h3>
              </button>
            </div>
          </div>
          <div class="row" v-if="step === 6">
            <div class="col-lg-4">
              <button type="button" @click="startNewApplication">
                <h3>Done</h3>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <b-modal
      id="confirm-submit-modal"
      centered
      title="Confirm Submission"
      ok-title="Yes, Submit"
      cancel-title="Review Again"
      @ok="submitApplication"
    >
      <p>
        Are you sure you want to submit your merchant application?
        Our team will review the details and get back to you.
      </p>
    </b-modal>

    <!-- Call To Action -->
    <section class="call-to-action text-center" id="call-to-action">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3>Get your Safe Money Wallet today.</h3>
            <router-link :to="{ name: 'app' }">Get Now</router-link>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <SubscribeForm source="Merchant application"></SubscribeForm>
</div>
        </div>
      </div>
    </section>

    <b-toast
      id="error-toast"
      variant="warning"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Required error</strong>
      </div>
      <div>
        <p>{{ errors.form || message }}</p>
      </div>
    </b-toast>

    <b-toast
      id="success-toast"
      variant="success"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Application Submitted</strong>
      </div>
      <div>
        <p>{{ successText }}</p>
      </div>
    </b-toast>

    <Footer />
  </div>
</template>
<script>
import Header from "./HeaderNew.vue";
import SubscribeForm from "./SubscribeForm.vue";
import Footer from "./FooterNew.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState, mapActions } from "vuex";

const STORAGE_KEY = "merchantApplyDraft";

export default {
  components: { SubscribeForm,
    Footer,
    Header,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      onChangeStateValue: "",
      errors: {},
      successText: "",
      confirmed: false,
      step: 1,
      totalSteps: 5,
      // Exactly the POST merchant/apply JSON schema (17 fields)
      form: {
        company_name: "",
        website_url: "",
        owner_full_name: "",
        contact_person_name: "",
        contact_person_email: "",
        contact_person_country_code: "",
        contact_person_number: "",
        business_email: "",
        business_phone_country_code: "",
        business_phone_number: "",
        registration_number: "",
        tax_number: "",
        company_address: "",
        country: "",
        state: "",
        city: "",
        zip_code: "",
      },
      valid_email:/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      valid_url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
      valid_phone: /^[0-9]{6,15}$/,
      valid_code: /^\+?[0-9]{1,5}$/,
    };
  },
  computed: {
    ...mapState(["successmessage", "errormessage", "message", "countries", "registerErrors"]),
    countryOptions: function () {
      const list = Array.isArray(this.countries) ? this.countries : [];
      return list
        .map(function (c) {
          if (typeof c === "string") { return { name: c, code: "" }; }
          if (!c) { return null; }
          return {
            name: c.name || c.country_name || c.title || c.country,
            code: c.country_dialing_code || c.dialing_code || c.phone_code || "",
          };
        })
        .filter(function (c) { return c && c.name; });
    },
    previewSections: function () {
      const f = this.form;
      const joinPhone = function (code, number) {
        if (!number) { return ""; }
        return code ? "+" + String(code).replace(/^\+/, "") + " " + number : number;
      };
      return [
        {
          step: 1,
          title: "Company Details",
          items: [
            { label: "Company Name", value: f.company_name },
            { label: "Owner's Full Name", value: f.owner_full_name },
            { label: "Website URL", value: f.website_url },
            { label: "Registration Number", value: f.registration_number },
            { label: "Tax / VAT / PAN Number", value: f.tax_number },
          ],
        },
        {
          step: 2,
          title: "Company Address",
          items: [
            { label: "Company Address", value: f.company_address },
            { label: "Country", value: f.country },
            { label: "State / Province", value: f.state },
            { label: "City", value: f.city },
            { label: "Zip / Postal Code", value: f.zip_code },
          ],
        },
        {
          step: 3,
          title: "Contact Person",
          items: [
            { label: "Contact Person Name", value: f.contact_person_name },
            { label: "Contact Person Email", value: f.contact_person_email },
            { label: "Contact Person Number", value: joinPhone(f.contact_person_country_code, f.contact_person_number) },
          ],
        },
        {
          step: 4,
          title: "Business Contact",
          items: [
            { label: "Business Email", value: f.business_email },
            { label: "Business Phone Number", value: joinPhone(f.business_phone_country_code, f.business_phone_number) },
          ],
        },
      ];
    },
  },
  created() {
    this.listCountries();
    this.restoreDraft();
  },
  methods: {
    ...mapActions(["listCountries", "submitMerchantApply"]),

    showError(msg) {
      this.errors = { form: msg };
      this.$bvToast.show("error-toast");
    },

    // Pre-fill both dialing codes from the selected country (still editable)
    onCountryChange() {
      const match = this.countryOptions.filter(
        function (c) { return c.name === this.form.country; }.bind(this)
      );
      if (!match.length || !match[0].code) { return; }
      const code = String(match[0].code).replace(/^\+/, "");
      if (!this.form.contact_person_country_code) { this.form.contact_person_country_code = code; }
      if (!this.form.business_phone_country_code) { this.form.business_phone_country_code = code; }
    },

    validateStep(step) {
      const f = this.form;
      if (step === 1) {
        if (!f.company_name) { this.showError("Company Name is required."); return false; }
        if (!f.owner_full_name) { this.showError("Owner's Full Name is required."); return false; }
        if (f.website_url && !this.valid_url.test(f.website_url)) { this.showError("Invalid Website URL."); return false; }
        if (!f.registration_number) { this.showError("Business Registration Number is required."); return false; }
      } else if (step === 2) {
        if (!f.company_address) { this.showError("Company Address is required."); return false; }
        if (!f.country) { this.showError("Country is required."); return false; }
        if (!f.city) { this.showError("City is required."); return false; }
      } else if (step === 3) {
        if (!f.contact_person_name) { this.showError("Contact Person Name is required."); return false; }
        if (!f.contact_person_email) { this.showError("Contact Person Email is required."); return false; }
        if (!this.valid_email.test(f.contact_person_email)) { this.showError("Invalid Contact Person Email."); return false; }
        if (!f.contact_person_country_code) { this.showError("Contact Person Country Code is required."); return false; }
        if (!this.valid_code.test(f.contact_person_country_code)) { this.showError("Invalid Country Code (digits only, e.g. 977)."); return false; }
        if (!f.contact_person_number) { this.showError("Contact Person Number is required."); return false; }
        if (!this.valid_phone.test(f.contact_person_number)) { this.showError("Enter the number without the country code (6-15 digits)."); return false; }
      } else if (step === 4) {
        if (!f.business_email) { this.showError("Business Email is required."); return false; }
        if (!this.valid_email.test(f.business_email)) { this.showError("Invalid Business Email."); return false; }
        if (!f.business_phone_country_code) { this.showError("Business Phone Country Code is required."); return false; }
        if (!this.valid_code.test(f.business_phone_country_code)) { this.showError("Invalid Country Code (digits only, e.g. 977)."); return false; }
        if (!f.business_phone_number) { this.showError("Business Phone Number is required."); return false; }
        if (!this.valid_phone.test(f.business_phone_number)) { this.showError("Enter the number without the country code (6-15 digits)."); return false; }
      }
      this.errors = {};
      return true;
    },

    nextStep(e) {
      if (e) { e.preventDefault(); }
      if (!this.validateStep(this.step)) { return; }
      this.saveDraft();
      if (this.step < this.totalSteps) {
        this.step = this.step + 1;
        this.scrollTop();
      }
    },

    prevStep() {
      if (this.step > 1) {
        this.step = this.step - 1;
        this.errors = {};
        this.scrollTop();
      }
    },

    goToStep(target) {
      this.step = target;
      this.errors = {};
      this.scrollTop();
    },

    askConfirm() {
      for (let s = 1; s <= 4; s++) {
        if (!this.validateStep(s)) {
          this.step = s;
          this.scrollTop();
          return;
        }
      }
      if (!this.confirmed) {
        this.showError("Please confirm that the information above is correct.");
        return;
      }
      this.$bvModal.show("confirm-submit-modal");
    },

    // Send every schema key, trimmed. Country codes go without a leading "+".
    buildPayload() {
      const f = this.form;
      const clean = function (v) { return v === null || v === undefined ? "" : String(v).trim(); };
      return {
        company_name: clean(f.company_name),
        website_url: clean(f.website_url),
        owner_full_name: clean(f.owner_full_name),
        contact_person_name: clean(f.contact_person_name),
        contact_person_email: clean(f.contact_person_email),
        contact_person_country_code: clean(f.contact_person_country_code).replace(/^\+/, ""),
        contact_person_number: clean(f.contact_person_number),
        business_email: clean(f.business_email),
        business_phone_country_code: clean(f.business_phone_country_code).replace(/^\+/, ""),
        business_phone_number: clean(f.business_phone_number),
        registration_number: clean(f.registration_number),
        tax_number: clean(f.tax_number),
        company_address: clean(f.company_address),
        country: clean(f.country),
        state: clean(f.state),
        city: clean(f.city),
        zip_code: clean(f.zip_code),
      };
    },

    submitApplication() {
      this.isLoading = true;
      const vm = this;
      return this.submitMerchantApply(this.buildPayload())
        .then(function () {
          if (vm.successmessage === "success") {
            vm.successText = vm.message || "Your merchant application has been submitted.";
            vm.$bvToast.show("success-toast");
            vm.clearDraft();
            vm.step = 6;
            vm.scrollTop();
          } else {
            // Surface a field error from the API if there is one
            const fieldErrors = vm.registerErrors || {};
            const keys = Object.keys(fieldErrors);
            vm.showError(keys.length ? fieldErrors[keys[0]] : (vm.message || "Unable to submit the application."));
          }
        })
        .catch(function () {
          vm.showError("Unable to submit the application. Please try again.");
        })
        .then(function () {
          vm.isLoading = false;
        });
    },

    startNewApplication() {
      const vm = this;
      Object.keys(this.form).forEach(function (k) { vm.form[k] = ""; });
      this.confirmed = false;
      this.successText = "";
      this.errors = {};
      this.step = 1;
      this.scrollTop();
    },

    saveDraft() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.form));
      } catch (e) {
        // storage unavailable - the form still works in memory
      }
    },

    restoreDraft() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) { return; }
        const draft = JSON.parse(raw);
        if (!draft) { return; }
        Object.keys(draft).forEach(
          function (key) {
            if (Object.prototype.hasOwnProperty.call(this.form, key) && draft[key]) {
              this.form[key] = draft[key];
            }
          }.bind(this)
        );
      } catch (e) {
        // corrupted draft - ignore
      }
    },

    clearDraft() {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        // ignore
      }
    },

    scrollTop() {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 100);
    },

  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  },
};
</script>
<style lang="scss" scoped>
.merchant {
  padding-block-start: 120px;

  h3 {
    color: #000;
    text-align: center;
    margin-block-end: 20px;
    font-size: 20px;
  }
  form {
    background: #f7f9fa;
    border: 1px solid rgba(0, 0, 0, 0.14);
    padding: 54px 43px;
    margin-bottom: 100px;
    button {
      background: #ed1a3b;
      color: #fff;
      border: none;
      height: 70px;
      width: 100%;
      border-radius: 30px;
      padding-top: 15px;
      padding-left: 30px;
      &:hover {
        background: #c70926;
      }
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
      h3 {
        color: #fff;
        text-align: left;
        font-size: 24px;
        font-weight: 700;
      }
      &.btn-back {
        background: #6c757d;
        &:hover {
          background: #5a6268;
        }
      }
    }
    input,
    select {
      width: 100%;
      font-size: 18px;
      font-family: "Poppins", sans-serif;
      height: 70px;
    }
    input[type="file"] {
      padding-top: 20px;
      background: #fff;
    }
    input[type="checkbox"] {
      width: auto;
      height: auto;
      margin-right: 10px;
    }
    label {
      width: 100%;
      h3 {
        text-align: left;
      }
      input,
      select {
        width: 100%;
        margin: 0px;
      }
    }
  }
}

.file-hint {
  display: block;
  color: #6c757d;
  font-size: 14px;
  margin-top: 6px;
}

.preview-title {
  text-align: left !important;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 25px;
}

.preview-block {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  border-radius: 8px;
  padding: 20px 25px;
  margin-bottom: 25px;
}

.preview-heading {
  text-align: left !important;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 15px !important;
}

.modify-link {
  color: #ed1a3b;
  font-weight: 600;
  text-decoration: underline;
  font-size: 16px;
}

.preview-row {
  padding: 8px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.preview-label {
  color: #6c757d;
  font-size: 16px;
}

.preview-value {
  color: #000;
  font-size: 16px;
  font-weight: 600;
  word-break: break-word;
}

.confirm-label {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 20px;
}

.confirm-box {
  width: auto !important;
  height: auto !important;
}
</style>
